export class RecordArmController {
    private static instance: RecordArmController | null = null;
    private armedTracks: Set<number> = new Set();
    private monitoringTracks: Set<number> = new Set();
    private currentRecordingTick: number | null = null;

    private constructor() { }
    public static getInstance(): RecordArmController {
        if (RecordArmController.instance == null) {
            RecordArmController.instance = new RecordArmController();
        }
        return RecordArmController.instance;
    }

    public isTrackArmed(trackIndex: number): boolean {
        return this.armedTracks.has(trackIndex);
    }

    public armTrack(trackIndex: number) {
        this.armedTracks.add(trackIndex);
    }

    public disarmTrack(trackIndex: number) {
        this.armedTracks.delete(trackIndex);
    }

    public isTrackMonitoring(trackIndex: number): boolean {
        return this.monitoringTracks.has(trackIndex);
    }

    public monitorTrack(trackIndex: number) {
        this.monitoringTracks.add(trackIndex);
    }

    public unmonitorTrack(trackIndex: number) {
        this.monitoringTracks.delete(trackIndex);
    }

    public unsetCurrentRecordingTick() {
        this.currentRecordingTick = null;
    }

    public setCurrentRecordingTick(tick: number) {
        this.currentRecordingTick = tick;
    }

    public incrementCurrentRecordingTick() {
        if (this.currentRecordingTick == null) return;
        this.currentRecordingTick++;
    }

    public getCurrentRecordingTick(): number | null {
        return this.currentRecordingTick;
    }

    public clearArmedTracks() {
        this.armedTracks.clear();
    }

    public clearMonitoringTracks() {
        this.monitoringTracks.clear();
    }
}